export function hasChanged(currentValue: any, initialValue: any): boolean {
    return (currentValue ?? '') !== (initialValue ?? '');
}